export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_LOADING = "REGISTER_LOADING";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const SEND_CONFIRM_EMAIL_SUCCESS = "SEND_CONFIRM_EMAIL_SUCCESS";
export const SEND_CONFIRM_EMAIL_LOADING = "SEND_CONFIRM_EMAIL_LOADING";
export const SEND_CONFIRM_EMAIL_ERROR = "SEND_CONFIRM_EMAIL_ERROR";
export const CONFIRM_EMAIL_SUCCESS = "CONFIRM_EMAIL_SUCCESS";
export const CONFIRM_EMAIL_LOADING = "CONFIRM_EMAIL_LOADING";
export const CONFIRM_EMAIL_ERROR = "CONFIRM_EMAIL_ERROR";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_LOADING = "FORGET_PASSWORD_LOADING";
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_LOADING = "RESET_PASSWORD_LOADING";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const FILE_UPLOAD_SUCCESS = "FILE_UPLOAD_SUCCESS";
export const FILE_UPLOAD_LOADING = "FILE_UPLOAD_LOADING";
export const FILE_UPLOAD_ERROR = "FILE_UPLOAD_ERROR";
export const GET_UPLOADED_FILE_SUCCESS = "GET_UPLOADED_FILE_SUCCESS";
export const GET_UPLOADED_FILE_LOADING = "GET_UPLOADED_FILE_LOADING";
export const GET_UPLOADED_FILE_ERROR = "GET_UPLOADED_FILE_ERROR";
export const DELETE_UPLOADED_FILE_SUCCESS = "DELETE_UPLOADED_FILE_SUCCESS";
export const DELETE_UPLOADED_FILE_LOADING = "DELETE_UPLOADED_FILE_LOADING";
export const DELETE_UPLOADED_FILE_ERROR = "DELETE_UPLOADED_FILE_ERROR";
export const DELETE_MULTIPLE_UPLOADED_FILE_SUCCESS = "DELETE_MULTIPLE_UPLOADED_FILE_SUCCESS";
export const DELETE_MULTIPLE_UPLOADED_FILE_LOADING = "DELETE_MULTIPLE_UPLOADED_FILE_LOADING";
export const DELETE_MULTIPLE_UPLOADED_FILE_ERROR = "DELETE_MULTIPLE_UPLOADED_FILE_ERROR";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_LOADING = "UPDATE_PROFILE_LOADING";
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_LOADING = "GET_PROFILE_LOADING";
export const GET_PROFILE_ERROR = "GET_PROFILE_ERROR";
export const UPDATE_SITE_DETAILS_SUCCESS = "UPDATE_SITE_DETAILS_SUCCESS";
export const UPDATE_SITE_DETAILS_LOADING = "UPDATE_SITE_DETAILS_LOADING";
export const UPDATE_SITE_DETAILS_ERROR = "UPDATE_SITE_DETAILS_ERROR";
export const GET_SITE_DETAILS_SUCCESS = "GET_SITE_DETAILS_SUCCESS";
export const GET_SITE_DETAILS_LOADING = "GET_SITE_DETAILS_LOADING";
export const GET_SITE_DETAILS_ERROR = "GET_SITE_DETAILS_ERROR";
export const UPDATE_SOCIAL_LINKS_SUCCESS = "UPDATE_SOCIAL_LINKS_SUCCESS";
export const UPDATE_SOCIAL_LINKS_LOADING = "UPDATE_SOCIAL_LINKS_LOADING";
export const UPDATE_SOCIAL_LINKS_ERROR = "UPDATE_SOCIAL_LINKS_ERROR";
export const GET_SOCIAL_LINKS_SUCCESS = "GET_SOCIAL_LINKS_SUCCESS";
export const GET_SOCIAL_LINKS_LOADING = "GET_SOCIAL_LINKS_LOADING";
export const GET_SOCIAL_LINKS_ERROR = "GET_SOCIAL_LINKS_ERROR";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_LOADING = "UPDATE_PASSWORD_LOADING";
export const UPDATE_PASSWORD_ERROR = "UPDATE_PASSWORD_ERROR";
export const GET_USERS_DETAILS_SUCCESS = "GET_USERS_DETAILS_SUCCESS";
export const GET_USERS_DETAILS_LOADING = "GET_USERS_DETAILS_LOADING";
export const GET_USERS_DETAILS_ERROR = "GET_USERS_DETAILS_ERROR";
export const GET_USERS_LIST_SUCCESS = "GET_USERS_LIST_SUCCESS";
export const GET_USERS_LIST_LOADING = "GET_USERS_LIST_LOADING";
export const GET_USERS_LIST_ERROR = "GET_USERS_LIST_ERROR";
export const GET_PAYMENT_METHOD_SUCCESS = "GET_PAYMENT_METHOD_SUCCESS";
export const GET_PAYMENT_METHOD_LOADING = "GET_PAYMENT_METHOD_LOADING";
export const GET_PAYMENT_METHOD_ERROR = "GET_PAYMENT_METHOD_ERROR";
export const UPDATE_PAYMENT_METHOD_SUCCESS = "UPDATE_PAYMENT_METHOD_SUCCESS";
export const UPDATE_PAYMENT_METHOD_LOADING = "UPDATE_PAYMENT_METHOD_LOADING";
export const UPDATE_PAYMENT_METHOD_ERROR = "UPDATE_PAYMENT_METHOD_ERROR";
export const UPDATE_PAYMENT_METHOD_STATUS_SUCCESS = "UPDATE_PAYMENT_METHOD_STATUS_SUCCESS";
export const UPDATE_PAYMENT_METHOD_STATUS_LOADING = "UPDATE_PAYMENT_METHOD_STATUS_LOADING";
export const UPDATE_PAYMENT_METHOD_STATUS_ERROR = "UPDATE_PAYMENT_METHOD_STATUS_ERROR";
export const ADD_PAYMENT_METHOD_SUCCESS = "ADD_PAYMENT_METHOD_SUCCESS";
export const ADD_PAYMENT_METHOD_LOADING = "ADD_PAYMENT_METHOD_LOADING";
export const ADD_PAYMENT_METHOD_ERROR = "ADD_PAYMENT_METHOD_ERROR";
export const DELETE_PAYMENT_METHOD_SUCCESS = "DELETE_PAYMENT_METHOD_SUCCESS";
export const DELETE_PAYMENT_METHOD_LOADING = "DELETE_PAYMENT_METHOD_LOADING";
export const DELETE_PAYMENT_METHOD_ERROR = "DELETE_PAYMENT_METHOD_ERROR";
export const GET_DASHBOARD_DETAILS_SUCCESS = "GET_DASHBOARD_DETAILS_SUCCESS";
export const GET_DASHBOARD_DETAILS_LOADING = "GET_DASHBOARD_DETAILS_LOADING";
export const GET_DASHBOARD_DETAILS_ERROR = "GET_DASHBOARD_DETAILS_ERROR";
export const VERIFY_TOKEN_SUCCESS = "VERIFY_TOKEN_SUCCESS";
export const VERIFY_TOKEN_LOADING = "VERIFY_TOKEN_LOADING";
export const VERIFY_TOKEN_ERROR = "VERIFY_TOKEN_ERROR";
export const UPDATE_APP_DETAILS_SUCCESS = "UPDATE_APP_DETAILS_SUCCESS";
export const UPDATE_APP_DETAILS_LOADING = "UPDATE_APP_DETAILS_LOADING";
export const UPDATE_APP_DETAILS_ERROR = "UPDATE_APP_DETAILS_ERROR";
export const UPDATE_APP_CURRENCY_DETAILS_SUCCESS = "UPDATE_APP_CURRENCY_DETAILS_SUCCESS";
export const UPDATE_APP_CURRENCY_DETAILS_LOADING = "UPDATE_APP_CURRENCY_DETAILS_LOADING";
export const UPDATE_APP_CURRENCY_DETAILS_ERROR = "UPDATE_APP_CURRENCY_DETAILS_ERROR";
export const GET_APP_DETAILS_SUCCESS = "GET_APP_DETAILS_SUCCESS";
export const GET_APP_DETAILS_LOADING = "GET_APP_DETAILS_LOADING";
export const GET_APP_DETAILS_ERROR = "GET_APP_DETAILS_ERROR";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_LOADING = "GET_CATEGORIES_LOADING";
export const GET_CATEGORIES_ERROR = "GET_CATEGORIES_ERROR";
export const UPDATE_CATEGORIES_SUCCESS = "UPDATE_CATEGORIES_SUCCESS";
export const UPDATE_CATEGORIES_LOADING = "UPDATE_CATEGORIES_LOADING";
export const UPDATE_CATEGORIES_ERROR = "UPDATE_CATEGORIES_ERROR";
export const ADD_CATEGORIES_SUCCESS = "ADD_CATEGORIES_SUCCESS";
export const ADD_CATEGORIES_LOADING = "ADD_CATEGORIES_LOADING";
export const ADD_CATEGORIES_ERROR = "ADD_CATEGORIES_ERROR";
export const DELETE_CATEGORIES_SUCCESS = "DELETE_CATEGORIES_SUCCESS";
export const DELETE_CATEGORIES_LOADING = "DELETE_CATEGORIES_LOADING";
export const DELETE_CATEGORIES_ERROR = "DELETE_CATEGORIES_ERROR";
export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS";
export const GET_TAGS_LOADING = "GET_TAGS_LOADING";
export const GET_TAGS_ERROR = "GET_TAGS_ERROR";
export const UPDATE_TAGS_SUCCESS = "UPDATE_TAGS_SUCCESS";
export const UPDATE_TAGS_LOADING = "UPDATE_TAGS_LOADING";
export const UPDATE_TAGS_ERROR = "UPDATE_TAGS_ERROR";
export const ADD_TAGS_SUCCESS = "ADD_TAGS_SUCCESS";
export const ADD_TAGS_LOADING = "ADD_TAGS_LOADING";
export const ADD_TAGS_ERROR = "ADD_TAGS_ERROR";
export const DELETE_TAGS_SUCCESS = "DELETE_TAGS_SUCCESS";
export const DELETE_TAGS_LOADING = "DELETE_TAGS_LOADING";
export const DELETE_TAGS_ERROR = "DELETE_TAGS_ERROR";
export const REORDER_TAGS_PRIORITY_SUCCESS = "REORDER_TAGS_PRIORITY_SUCCESS";
export const REORDER_TAGS_PRIORITY_LOADING = "REORDER_TAGS_PRIORITY_LOADING";
export const REORDER_TAGS_PRIORITY_ERROR = "REORDER_TAGS_PRIORITY_ERROR";
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS";
export const GET_LANGUAGES_LOADING = "GET_LANGUAGES_LOADING";
export const GET_LANGUAGES_ERROR = "GET_LANGUAGES_ERROR";
export const UPDATE_LANGUAGES_SUCCESS = "UPDATE_LANGUAGES_SUCCESS";
export const UPDATE_LANGUAGES_LOADING = "UPDATE_LANGUAGES_LOADING";
export const UPDATE_LANGUAGES_ERROR = "UPDATE_LANGUAGES_ERROR";
export const ADD_LANGUAGES_SUCCESS = "ADD_LANGUAGES_SUCCESS";
export const ADD_LANGUAGES_LOADING = "ADD_LANGUAGES_LOADING";
export const ADD_LANGUAGES_ERROR = "ADD_LANGUAGES_ERROR";
export const DELETE_LANGUAGES_SUCCESS = "DELETE_LANGUAGES_SUCCESS";
export const DELETE_LANGUAGES_LOADING = "DELETE_LANGUAGES_LOADING";
export const DELETE_LANGUAGES_ERROR = "DELETE_LANGUAGES_ERROR";
export const GET_TYPES_SUCCESS = "GET_TYPES_SUCCESS";
export const GET_TYPES_LOADING = "GET_TYPES_LOADING";
export const GET_TYPES_ERROR = "GET_TYPES_ERROR";
export const UPDATE_TYPES_SUCCESS = "UPDATE_TYPES_SUCCESS";
export const UPDATE_TYPES_LOADING = "UPDATE_TYPES_LOADING";
export const UPDATE_TYPES_ERROR = "UPDATE_TYPES_ERROR";
export const ADD_TYPES_SUCCESS = "ADD_TYPES_SUCCESS";
export const ADD_TYPES_LOADING = "ADD_TYPES_LOADING";
export const ADD_TYPES_ERROR = "ADD_TYPES_ERROR";
export const DELETE_TYPES_SUCCESS = "DELETE_TYPES_SUCCESS";
export const DELETE_TYPES_LOADING = "DELETE_TYPES_LOADING";
export const DELETE_TYPES_ERROR = "DELETE_TYPES_ERROR";
export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLANS_LOADING = "GET_PLANS_LOADING";
export const GET_PLANS_ERROR = "GET_PLANS_ERROR";
export const UPDATE_PLANS_SUCCESS = "UPDATE_PLANS_SUCCESS";
export const UPDATE_PLANS_LOADING = "UPDATE_PLANS_LOADING";
export const UPDATE_PLANS_ERROR = "UPDATE_PLANS_ERROR";
export const ADD_PLANS_SUCCESS = "ADD_PLANS_SUCCESS";
export const ADD_PLANS_LOADING = "ADD_PLANS_LOADING";
export const ADD_PLANS_ERROR = "ADD_PLANS_ERROR";
export const DELETE_PLANS_SUCCESS = "DELETE_PLANS_SUCCESS";
export const DELETE_PLANS_LOADING = "DELETE_PLANS_LOADING";
export const DELETE_PLANS_ERROR = "DELETE_PLANS_ERROR";
export const GET_SERIES_SUCCESS = "GET_SERIES_SUCCESS";
export const GET_SERIES_LOADING = "GET_SERIES_LOADING";
export const GET_SERIES_ERROR = "GET_SERIES_ERROR";
export const GET_SERIES_DETAILS_SUCCESS = "GET_SERIES_DETAILS_SUCCESS";
export const GET_SERIES_DETAILS_LOADING = "GET_SERIES_DETAILS_LOADING";
export const GET_SERIES_DETAILS_ERROR = "GET_SERIES_DETAILS_ERROR";
export const UPDATE_SERIES_SUCCESS = "UPDATE_SERIES_SUCCESS";
export const UPDATE_SERIES_LOADING = "UPDATE_SERIES_LOADING";
export const UPDATE_SERIES_ERROR = "UPDATE_SERIES_ERROR";
export const UPDATE_RECOMMANDED_SERIES_SUCCESS = "UPDATE_RECOMMANDED_SERIES_SUCCESS";
export const UPDATE_RECOMMANDED_SERIES_LOADING = "UPDATE_RECOMMANDED_SERIES_LOADING";
export const UPDATE_RECOMMANDED_SERIES_ERROR = "UPDATE_RECOMMANDED_SERIES_ERROR";
export const UPDATE_ACTIVE_SERIES_SUCCESS = "UPDATE_ACTIVE_SERIES_SUCCESS";
export const UPDATE_ACTIVE_SERIES_LOADING = "UPDATE_ACTIVE_SERIES_LOADING";
export const UPDATE_ACTIVE_SERIES_ERROR = "UPDATE_ACTIVE_SERIES_ERROR";
export const UPDATE_FREE_SERIES_SUCCESS = "UPDATE_FREE_SERIES_SUCCESS";
export const UPDATE_FREE_SERIES_LOADING = "UPDATE_FREE_SERIES_LOADING";
export const UPDATE_FREE_SERIES_ERROR = "UPDATE_FREE_SERIES_ERROR";
export const ADD_SERIES_SUCCESS = "ADD_SERIES_SUCCESS";
export const ADD_SERIES_LOADING = "ADD_SERIES_LOADING";
export const ADD_SERIES_ERROR = "ADD_SERIES_ERROR";
export const DELETE_SERIES_SUCCESS = "DELETE_SERIES_SUCCESS";
export const DELETE_SERIES_LOADING = "DELETE_SERIES_LOADING";
export const DELETE_SERIES_ERROR = "DELETE_SERIES_ERROR";
export const GET_EPISODES_SUCCESS = "GET_EPISODES_SUCCESS";
export const GET_EPISODES_LOADING = "GET_EPISODES_LOADING";
export const GET_EPISODES_ERROR = "GET_EPISODES_ERROR";
export const GET_EPISODES_DETAILS_SUCCESS = "GET_EPISODES_DETAILS_SUCCESS";
export const GET_EPISODES_DETAILS_LOADING = "GET_EPISODES_DETAILS_LOADING";
export const GET_EPISODES_DETAILS_ERROR = "GET_EPISODES_DETAILS_ERROR";
export const UPDATE_EPISODES_SUCCESS = "UPDATE_EPISODES_SUCCESS";
export const UPDATE_EPISODES_LOADING = "UPDATE_EPISODES_LOADING";
export const UPDATE_EPISODES_ERROR = "UPDATE_EPISODES_ERROR";
export const ADD_EPISODES_SUCCESS = "ADD_EPISODES_SUCCESS";
export const ADD_EPISODES_LOADING = "ADD_EPISODES_LOADING";
export const ADD_EPISODES_ERROR = "ADD_EPISODES_ERROR";
export const ADD_EPISODES_URLS_SUCCESS = "ADD_EPISODES_URLS_SUCCESS";
export const ADD_EPISODES_URLS_LOADING = "ADD_EPISODES_URLS_LOADING";
export const ADD_EPISODES_URLS_ERROR = "ADD_EPISODES_URLS_ERROR";
export const DELETE_EPISODES_SUCCESS = "DELETE_EPISODES_SUCCESS";
export const DELETE_EPISODES_LOADING = "DELETE_EPISODES_LOADING";
export const DELETE_EPISODES_ERROR = "DELETE_EPISODES_ERROR";
export const UPDATE_ABOUT_US_SUCCESS = "UPDATE_ABOUT_US_SUCCESS";
export const UPDATE_ABOUT_US_LOADING = "UPDATE_ABOUT_US_LOADING";
export const UPDATE_ABOUT_US_ERROR = "UPDATE_ABOUT_US_ERROR";
export const GET_ABOUT_US_SUCCESS = "GET_ABOUT_US_SUCCESS";
export const GET_ABOUT_US_LOADING = "GET_ABOUT_US_LOADING";
export const GET_ABOUT_US_ERROR = "GET_ABOUT_US_ERROR";
export const UPDATE_TERMS_CONDITIONS_SUCCESS = "UPDATE_TERMS_CONDITIONS_SUCCESS";
export const UPDATE_TERMS_CONDITIONS_LOADING = "UPDATE_TERMS_CONDITIONS_LOADING";
export const UPDATE_TERMS_CONDITIONS_ERROR = "UPDATE_TERMS_CONDITIONS_ERROR";
export const GET_TERMS_CONDITIONS_SUCCESS = "GET_TERMS_CONDITIONS_SUCCESS";
export const GET_TERMS_CONDITIONS_LOADING = "GET_TERMS_CONDITIONS_LOADING";
export const GET_TERMS_CONDITIONS_ERROR = "GET_TERMS_CONDITIONS_ERROR";
export const UPDATE_PRIVACY_POLICY_SUCCESS = "UPDATE_PRIVACY_POLICY_SUCCESS";
export const UPDATE_PRIVACY_POLICY_LOADING = "UPDATE_PRIVACY_POLICY_LOADING";
export const UPDATE_PRIVACY_POLICY_ERROR = "UPDATE_PRIVACY_POLICY_ERROR";
export const GET_PRIVACY_POLICY_SUCCESS = "GET_PRIVACY_POLICY_SUCCESS";
export const GET_PRIVACY_POLICY_LOADING = "GET_PRIVACY_POLICY_LOADING";
export const GET_PRIVACY_POLICY_ERROR = "GET_PRIVACY_POLICY_ERROR";
export const GET_ADS_PLATFORM_SUCCESS = "GET_ADS_PLATFORM_SUCCESS";
export const GET_ADS_PLATFORM_LOADING = "GET_ADS_PLATFORM_LOADING";
export const GET_ADS_PLATFORM_ERROR = "GET_ADS_PLATFORM_ERROR";
export const UPDATE_STATUS_ADS_PLATFORM_SUCCESS = "UPDATE_STATUS_ADS_PLATFORM_SUCCESS";
export const UPDATE_STATUS_ADS_PLATFORM_LOADING = "UPDATE_STATUS_ADS_PLATFORM_LOADING";
export const UPDATE_STATUS_ADS_PLATFORM_ERROR = "UPDATE_STATUS_ADS_PLATFORM_ERROR";
export const GET_ADS_PLATFORM_DETAILS_SUCCESS = "GET_ADS_PLATFORM_DETAILS_SUCCESS";
export const GET_ADS_PLATFORM_DETAILS_LOADING = "GET_ADS_PLATFORM_DETAILS_LOADING";
export const GET_ADS_PLATFORM_DETAILS_ERROR = "GET_ADS_PLATFORM_DETAILS_ERROR";
export const UPDATE_ADS_PLATFORM_DETAILS_SUCCESS = "UPDATE_ADS_PLATFORM_DETAILS_SUCCESS";
export const UPDATE_ADS_PLATFORM_DETAILS_LOADING = "UPDATE_ADS_PLATFORM_DETAILS_LOADING";
export const UPDATE_ADS_PLATFORM_DETAILS_ERROR = "UPDATE_ADS_PLATFORM_DETAILS_ERROR";
export const UPDATE_IS_BLOCKED_SUCCESS = "UPDATE_IS_BLOCKED_SUCCESS";
export const UPDATE_IS_BLOCKED_LOADING = "UPDATE_IS_BLOCKED_LOADING";
export const UPDATE_IS_BLOCKED_ERROR = "UPDATE_IS_BLOCKED_ERROR";
export const GET_REWARD_HISTORY_SUCCESS = "GET_REWARD_HISTORY_SUCCESS";
export const GET_REWARD_HISTORY_LOADING = "GET_REWARD_HISTORY_LOADING";
export const GET_REWARD_HISTORY_ERROR = "GET_REWARD_HISTORY_ERROR";
export const GET_PURCHASE_COIN_HISTORY_SUCCESS = "GET_PURCHASE_COIN_HISTORY_SUCCESS";
export const GET_PURCHASE_COIN_HISTORY_LOADING = "GET_PURCHASE_COIN_HISTORY_LOADING";
export const GET_PURCHASE_COIN_HISTORY_ERROR = "GET_PURCHASE_COIN_HISTORY_ERROR";
export const GET_PURCHASE_VIP_HISTORY_SUCCESS = "GET_PURCHASE_VIP_HISTORY_SUCCESS";
export const GET_PURCHASE_VIP_HISTORY_LOADING = "GET_PURCHASE_VIP_HISTORY_LOADING";
export const GET_PURCHASE_VIP_HISTORY_ERROR = "GET_PURCHASE_VIP_HISTORY_ERROR";
export const UPDATE_IS_ACTIVE_PLAN_SUCCESS = "UPDATE_IS_ACTIVE_PLAN_SUCCESS";
export const UPDATE_IS_ACTIVE_PLAN_LOADING = "UPDATE_IS_ACTIVE_PLAN_LOADING";
export const UPDATE_IS_ACTIVE_PLAN_ERROR = "UPDATE_IS_ACTIVE_PLAN_ERROR";
export const GET_VIP_PLANS_SUCCESS = "GET_VIP_PLANS_SUCCESS";
export const GET_VIP_PLANS_LOADING = "GET_VIP_PLANS_LOADING";
export const GET_VIP_PLANS_ERROR = "GET_VIP_PLANS_ERROR";
export const GET_VIP_PURCHASE_HISTORY_SUCCESS = "GET_VIP_PURCHASE_HISTORY_SUCCESS";
export const GET_VIP_PURCHASE_HISTORY_LOADING = "GET_VIP_PURCHASE_HISTORY_LOADING";
export const GET_VIP_PURCHASE_HISTORY_ERROR = "GET_VIP_PURCHASE_HISTORY_ERROR";
export const GET_COIN_PURCHASE_HISTORY_SUCCESS = "GET_COIN_PURCHASE_HISTORY_SUCCESS";
export const GET_COIN_PURCHASE_HISTORY_LOADING = "GET_COIN_PURCHASE_HISTORY_LOADING";
export const GET_COIN_PURCHASE_HISTORY_ERROR = "GET_COIN_PURCHASE_HISTORY_ERROR";
export const GET_REPORT_REASON_SUCCESS = "GET_REPORT_REASON_SUCCESS";
export const GET_REPORT_REASON_LOADING = "GET_REPORT_REASON_LOADING";
export const GET_REPORT_REASON_ERROR = "GET_REPORT_REASON_ERROR";
export const UPDATE_REPORT_REASON_SUCCESS = "UPDATE_REPORT_REASON_SUCCESS";
export const UPDATE_REPORT_REASON_LOADING = "UPDATE_REPORT_REASON_LOADING";
export const UPDATE_REPORT_REASON_ERROR = "UPDATE_REPORT_REASON_ERROR";
export const ADD_REPORT_REASON_SUCCESS = "ADD_REPORT_REASON_SUCCESS";
export const ADD_REPORT_REASON_LOADING = "ADD_REPORT_REASON_LOADING";
export const ADD_REPORT_REASON_ERROR = "ADD_REPORT_REASON_ERROR";
export const DELETE_REPORT_REASON_SUCCESS = "DELETE_REPORT_REASON_SUCCESS";
export const DELETE_REPORT_REASON_LOADING = "DELETE_REPORT_REASON_LOADING";
export const DELETE_REPORT_REASON_ERROR = "DELETE_REPORT_REASON_ERROR";
export const GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS";
export const GET_TICKETS_LOADING = "GET_TICKETS_LOADING";
export const GET_TICKETS_ERROR = "GET_TICKETS_ERROR";
export const UPDATE_TICKET_STATUS_SUCCESS = "UPDATE_TICKET_STATUS_SUCCESS";
export const UPDATE_TICKET_STATUS_LOADING = "UPDATE_TICKET_STATUS_LOADING";
export const UPDATE_TICKET_STATUS_ERROR = "UPDATE_TICKET_STATUS_ERROR";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_LOADING = "GET_FAQ_LOADING";
export const GET_FAQ_ERROR = "GET_FAQ_ERROR";
export const UPDATE_FAQ_SUCCESS = "UPDATE_FAQ_SUCCESS";
export const UPDATE_FAQ_LOADING = "UPDATE_FAQ_LOADING";
export const UPDATE_FAQ_ERROR = "UPDATE_FAQ_ERROR";
export const ADD_FAQ_SUCCESS = "ADD_FAQ_SUCCESS";
export const ADD_FAQ_LOADING = "ADD_FAQ_LOADING";
export const ADD_FAQ_ERROR = "ADD_FAQ_ERROR";
export const DELETE_FAQ_SUCCESS = "DELETE_FAQ_SUCCESS";
export const DELETE_FAQ_LOADING = "DELETE_FAQ_LOADING";
export const DELETE_FAQ_ERROR = "DELETE_FAQ_ERROR";
export const SITE_DATA_SUCCESS = "SITE_DATA_SUCCESS";
export const SITE_DATA_LOADING = "SITE_DATA_LOADING";
export const SITE_DATA_ERROR = "SITE_DATA_ERROR";
export const VERIFY_LICENSE_SUCCESS = "VERIFY_LICENSE_SUCCESS";
export const VERIFY_LICENSE_LOADING = "VERIFY_LICENSE_LOADING";
export const VERIFY_LICENSE_ERROR = "VERIFY_LICENSE_ERROR";
export const GET_LICENSE_SUCCESS = "GET_LICENSE_SUCCESS";
export const GET_LICENSE_LOADING = "GET_LICENSE_LOADING";
export const GET_LICENSE_ERROR = "GET_LICENSE_ERROR";
export const SEND_NOTIFICATION_SUCCESS = "SEND_NOTIFICATION_SUCCESS";
export const SEND_NOTIFICATION_LOADING = "SEND_NOTIFICATION_LOADING";
export const SEND_NOTIFICATION_ERROR = "SEND_NOTIFICATION_ERROR";
export const GET_ANALYTICS_SUCCESS = "GET_ANALYTICS_SUCCESS";
export const GET_ANALYTICS_LOADING = "GET_ANALYTICS_LOADING";
export const GET_ANALYTICS_ERROR = "GET_ANALYTICS_ERROR";
export const GET_DAILY_ANALYTICS_SUCCESS = "GET_DAILY_ANALYTICS_SUCCESS";
export const GET_DAILY_ANALYTICS_LOADING = "GET_DAILY_ANALYTICS_LOADING";
export const GET_DAILY_ANALYTICS_ERROR = "GET_DAILY_ANALYTICS_ERROR";
export const GET_MONTHLY_ANALYTICS_SUCCESS = "GET_MONTHLY_ANALYTICS_SUCCESS";
export const GET_MONTHLY_ANALYTICS_LOADING = "GET_MONTHLY_ANALYTICS_LOADING";
export const GET_MONTHLY_ANALYTICS_ERROR = "GET_MONTHLY_ANALYTICS_ERROR";
export const GET_USER_GROWTH_SUCCESS = "GET_USER_GROWTH_SUCCESS";
export const GET_USER_GROWTH_LOADING = "GET_USER_GROWTH_LOADING";
export const GET_USER_GROWTH_ERROR = "GET_USER_GROWTH_ERROR";
export const GET_REVENUE_ANALYTICS_SUCCESS = "GET_REVENUE_ANALYTICS_SUCCESS";
export const GET_REVENUE_ANALYTICS_LOADING = "GET_REVENUE_ANALYTICS_LOADING";
export const GET_REVENUE_ANALYTICS_ERROR = "GET_REVENUE_ANALYTICS_ERROR";
export const GET_DAU_ANALYTICS_SUCCESS = "GET_DAU_ANALYTICS_SUCCESS";
export const GET_DAU_ANALYTICS_LOADING = "GET_DAU_ANALYTICS_LOADING";
export const GET_DAU_ANALYTICS_ERROR = "GET_DAU_ANALYTICS_ERROR";
export const GET_SERIES_VIEWS_SUCCESS = "GET_SERIES_VIEWS_SUCCESS";
export const GET_SERIES_VIEWS_LOADING = "GET_SERIES_VIEWS_LOADING";
export const GET_SERIES_VIEWS_ERROR = "GET_SERIES_VIEWS_ERROR";

// Hero Banner
export const GET_BANNERS_SUCCESS = "GET_BANNERS_SUCCESS";
export const GET_BANNERS_LOADING = "GET_BANNERS_LOADING";
export const GET_BANNERS_ERROR = "GET_BANNERS_ERROR";
export const ADD_BANNER_SUCCESS = "ADD_BANNER_SUCCESS";
export const ADD_BANNER_LOADING = "ADD_BANNER_LOADING";
export const ADD_BANNER_ERROR = "ADD_BANNER_ERROR";
export const UPDATE_BANNER_SUCCESS = "UPDATE_BANNER_SUCCESS";
export const UPDATE_BANNER_LOADING = "UPDATE_BANNER_LOADING";
export const UPDATE_BANNER_ERROR = "UPDATE_BANNER_ERROR";
export const DELETE_BANNER_SUCCESS = "DELETE_BANNER_SUCCESS";
export const DELETE_BANNER_LOADING = "DELETE_BANNER_LOADING";
export const DELETE_BANNER_ERROR = "DELETE_BANNER_ERROR";
export const GET_HERO_BANNER_ELIGIBLE_SERIES_SUCCESS = "GET_HERO_BANNER_ELIGIBLE_SERIES_SUCCESS";
export const GET_HERO_BANNER_ELIGIBLE_SERIES_LOADING = "GET_HERO_BANNER_ELIGIBLE_SERIES_LOADING";
export const GET_HERO_BANNER_ELIGIBLE_SERIES_ERROR = "GET_HERO_BANNER_ELIGIBLE_SERIES_ERROR";
export const UPDATE_HERO_BANNER_ELIGIBILITY_SUCCESS = "UPDATE_HERO_BANNER_ELIGIBILITY_SUCCESS";
export const UPDATE_HERO_BANNER_ELIGIBILITY_LOADING = "UPDATE_HERO_BANNER_ELIGIBILITY_LOADING";
export const UPDATE_HERO_BANNER_ELIGIBILITY_ERROR = "UPDATE_HERO_BANNER_ELIGIBILITY_ERROR";
export const REORDER_BANNERS_SUCCESS = "REORDER_BANNERS_SUCCESS";
export const REORDER_BANNERS_LOADING = "REORDER_BANNERS_LOADING";
export const REORDER_BANNERS_ERROR = "REORDER_BANNERS_ERROR";
export const GET_BANNERS_WITH_SERIES_SUCCESS = "GET_BANNERS_WITH_SERIES_SUCCESS";
export const GET_BANNERS_WITH_SERIES_LOADING = "GET_BANNERS_WITH_SERIES_LOADING";
export const GET_BANNERS_WITH_SERIES_ERROR = "GET_BANNERS_WITH_SERIES_ERROR";
export const UPLOAD_BANNER_IMAGE_SUCCESS = "UPLOAD_BANNER_IMAGE_SUCCESS";
export const UPLOAD_BANNER_IMAGE_LOADING = "UPLOAD_BANNER_IMAGE_LOADING";
export const UPLOAD_BANNER_IMAGE_ERROR = "UPLOAD_BANNER_IMAGE_ERROR";
export const GET_CURATED_COLLECTION_SUCCESS = "GET_CURATED_COLLECTION_SUCCESS";
export const GET_CURATED_COLLECTION_LOADING = "GET_CURATED_COLLECTION_LOADING";
export const GET_CURATED_COLLECTION_ERROR = "GET_CURATED_COLLECTION_ERROR";
export const SAVE_CURATED_COLLECTION_SUCCESS = "SAVE_CURATED_COLLECTION_SUCCESS";
export const SAVE_CURATED_COLLECTION_LOADING = "SAVE_CURATED_COLLECTION_LOADING";
export const SAVE_CURATED_COLLECTION_ERROR = "SAVE_CURATED_COLLECTION_ERROR";
export const GET_CURATION_SUCCESS = "GET_CURATION_SUCCESS";
export const GET_CURATION_LOADING = "GET_CURATION_LOADING";
export const GET_CURATION_ERROR = "GET_CURATION_ERROR";
export const PATCH_CURATION_SUCCESS = "PATCH_CURATION_SUCCESS";
export const PATCH_CURATION_LOADING = "PATCH_CURATION_LOADING";
export const PATCH_CURATION_ERROR = "PATCH_CURATION_ERROR";

export const CREATE_BULK_IMPORT_BATCH_SUCCESS = "CREATE_BULK_IMPORT_BATCH_SUCCESS";
export const CREATE_BULK_IMPORT_BATCH_LOADING = "CREATE_BULK_IMPORT_BATCH_LOADING";
export const CREATE_BULK_IMPORT_BATCH_ERROR = "CREATE_BULK_IMPORT_BATCH_ERROR";
export const VALIDATE_BULK_IMPORT_BATCH_SUCCESS = "VALIDATE_BULK_IMPORT_BATCH_SUCCESS";
export const VALIDATE_BULK_IMPORT_BATCH_LOADING = "VALIDATE_BULK_IMPORT_BATCH_LOADING";
export const VALIDATE_BULK_IMPORT_BATCH_ERROR = "VALIDATE_BULK_IMPORT_BATCH_ERROR";
export const START_BULK_IMPORT_BATCH_SUCCESS = "START_BULK_IMPORT_BATCH_SUCCESS";
export const START_BULK_IMPORT_BATCH_LOADING = "START_BULK_IMPORT_BATCH_LOADING";
export const START_BULK_IMPORT_BATCH_ERROR = "START_BULK_IMPORT_BATCH_ERROR";
export const RETRY_BULK_IMPORT_SERIES_ITEMS_SUCCESS = "RETRY_BULK_IMPORT_SERIES_ITEMS_SUCCESS";
export const RETRY_BULK_IMPORT_SERIES_ITEMS_LOADING = "RETRY_BULK_IMPORT_SERIES_ITEMS_LOADING";
export const RETRY_BULK_IMPORT_SERIES_ITEMS_ERROR = "RETRY_BULK_IMPORT_SERIES_ITEMS_ERROR";
export const CANCEL_BULK_IMPORT_BATCH_SUCCESS = "CANCEL_BULK_IMPORT_BATCH_SUCCESS";
export const CANCEL_BULK_IMPORT_BATCH_LOADING = "CANCEL_BULK_IMPORT_BATCH_LOADING";
export const CANCEL_BULK_IMPORT_BATCH_ERROR = "CANCEL_BULK_IMPORT_BATCH_ERROR";
export const PUBLISH_BULK_IMPORT_SERIES_SUCCESS = "PUBLISH_BULK_IMPORT_SERIES_SUCCESS";
export const PUBLISH_BULK_IMPORT_SERIES_LOADING = "PUBLISH_BULK_IMPORT_SERIES_LOADING";
export const PUBLISH_BULK_IMPORT_SERIES_ERROR = "PUBLISH_BULK_IMPORT_SERIES_ERROR";
export const GET_BULK_IMPORT_BATCHES_SUCCESS = "GET_BULK_IMPORT_BATCHES_SUCCESS";
export const GET_BULK_IMPORT_BATCHES_LOADING = "GET_BULK_IMPORT_BATCHES_LOADING";
export const GET_BULK_IMPORT_BATCHES_ERROR = "GET_BULK_IMPORT_BATCHES_ERROR";
export const GET_BULK_IMPORT_BATCH_DETAIL_SUCCESS = "GET_BULK_IMPORT_BATCH_DETAIL_SUCCESS";
export const GET_BULK_IMPORT_BATCH_DETAIL_LOADING = "GET_BULK_IMPORT_BATCH_DETAIL_LOADING";
export const GET_BULK_IMPORT_BATCH_DETAIL_ERROR = "GET_BULK_IMPORT_BATCH_DETAIL_ERROR";
export const GET_BULK_IMPORT_SERIES_ITEMS_SUCCESS = "GET_BULK_IMPORT_SERIES_ITEMS_SUCCESS";
export const GET_BULK_IMPORT_SERIES_ITEMS_LOADING = "GET_BULK_IMPORT_SERIES_ITEMS_LOADING";
export const GET_BULK_IMPORT_SERIES_ITEMS_ERROR = "GET_BULK_IMPORT_SERIES_ITEMS_ERROR";
export const GET_BULK_IMPORT_EPISODE_ITEMS_SUCCESS = "GET_BULK_IMPORT_EPISODE_ITEMS_SUCCESS";
export const GET_BULK_IMPORT_EPISODE_ITEMS_LOADING = "GET_BULK_IMPORT_EPISODE_ITEMS_LOADING";
export const GET_BULK_IMPORT_EPISODE_ITEMS_ERROR = "GET_BULK_IMPORT_EPISODE_ITEMS_ERROR";
export const GET_BULK_IMPORT_BROWSE_SUCCESS = "GET_BULK_IMPORT_BROWSE_SUCCESS";
export const GET_BULK_IMPORT_BROWSE_LOADING = "GET_BULK_IMPORT_BROWSE_LOADING";
export const GET_BULK_IMPORT_BROWSE_ERROR = "GET_BULK_IMPORT_BROWSE_ERROR";
export const GET_BULK_IMPORT_START_SUMMARY_SUCCESS = "GET_BULK_IMPORT_START_SUMMARY_SUCCESS";
export const GET_BULK_IMPORT_START_SUMMARY_LOADING = "GET_BULK_IMPORT_START_SUMMARY_LOADING";
export const GET_BULK_IMPORT_START_SUMMARY_ERROR = "GET_BULK_IMPORT_START_SUMMARY_ERROR";
export const RETRY_BULK_IMPORT_EPISODES_SUCCESS = "RETRY_BULK_IMPORT_EPISODES_SUCCESS";
export const RETRY_BULK_IMPORT_EPISODES_LOADING = "RETRY_BULK_IMPORT_EPISODES_LOADING";
export const RETRY_BULK_IMPORT_EPISODES_ERROR = "RETRY_BULK_IMPORT_EPISODES_ERROR";
export const GET_BULK_IMPORT_AUDIT_SUCCESS = "GET_BULK_IMPORT_AUDIT_SUCCESS";
export const GET_BULK_IMPORT_AUDIT_LOADING = "GET_BULK_IMPORT_AUDIT_LOADING";
export const GET_BULK_IMPORT_AUDIT_ERROR = "GET_BULK_IMPORT_AUDIT_ERROR";
